import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Distance Unit List with Query (for remote operations)
export const getDistanceUnitListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DISTANCE_UNITS}?${stringifyParams(
			params
		)}`
	);
};

// Get Distance Unit List with Query
export const getDistanceUnitList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DISTANCE_UNITS}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Distance Unit
export const getDistanceUnit = distance_unit_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DISTANCE_UNIT}${distance_unit_id}`
	);
};

// Add New Distance Unit
export const addNewDistanceUnitApi = distance_unit => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_DISTANCE_UNIT}`,
		distance_unit
	);
};

// Update Distance Unit
export const updateDistanceUnitApi = distance_unit => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_DISTANCE_UNIT}${distance_unit._id}`,
		distance_unit
	);
};

// Delete Distance Unit
export const deleteDistanceUnitApi = distance_unit_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_DISTANCE_UNIT}${distance_unit_id}`
	);
};

// Check if Distance Unit Exists
export const checkDistanceUnitExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_DISTANCE_UNIT_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
